// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import Http from "./http";
import appSettings from "../config/appSettings";
import StringHelper from "../helpers/stringHelper";
import oidcManager from "../authentication/oidcManager";

/**
 * Gets the Backend API Url
 * @returns {string} Backend API Url
 */
export const backendApiUrl = function (): string {
  let baseUrl = oidcManager.userProfile.mobicrm_backend_url;
  if (!baseUrl) {
    baseUrl = appSettings.BACKEND_URL;
    // Prefix backend endpoint with tenantId
    baseUrl = StringHelper.format(baseUrl, oidcManager.userProfile.tid);
  }
  return baseUrl + "/api/v1";
};

const backendClient = new Http(backendApiUrl);

export default backendClient;
